import { useEffect, useRef, useState } from 'react'
import { getDocumentNode } from 'services/documents'
import type { DocumentNode } from 'types/documents'
export interface MailDocumentMetadata { node?: DocumentNode; error?: string; loading?: boolean }
export function useMailAttachmentDocuments(ids: number[], sessionId: string) {
  const [metadata, setMetadata] = useState<Record<number, MailDocumentMetadata>>({})
  const generation = useRef(0)
  const key = ids.join(',')
  useEffect(() => {
    const context = ++generation.current
    const entries = Object.fromEntries(ids.map(id => [id, { loading: true }]))
    setMetadata(entries)
    let index = 0
    const worker = async () => {
      while (index < ids.length && generation.current === context) {
        const id = ids[index++]
        try {
          const node = await getDocumentNode(id)
          if (context === generation.current) setMetadata(current => ({ ...current, [id]: node.node_type === 'FILE' ? { node } : { error: 'Il documento non è un file allegabile.' } }))
        } catch { if (context === generation.current) setMetadata(current => ({ ...current, [id]: { error: 'Documento non accessibile. Rimuovilo o verifica l’accesso prima di inviare.' } })) }
      }
    }
    for (let i = 0; i < Math.min(4, ids.length); i++) void worker()
    return () => { generation.current++ }
  }, [key, sessionId])
  return metadata
}
